export default {"src":"/_next/static/media/header_bg_horizontal.7ac1ab07.svg","height":82,"width":203,"blurWidth":0,"blurHeight":0};